/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldZoneLayout } from "cms/fields/layout/";

export const getFieldZoneLayout = (props) => {
    const displayComponent = props?.displayComponent;
    const editComponent = props?.editComponent;
    return (
        <FieldZoneLayout
            displayComponent={displayComponent}
            editComponent={editComponent}
        />
    );
};
